// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const sdiCertOperations = {
  getParams: ['get', '/v1/params'] as const,
  createParams: ['put', '/v1/params'] as const,
  newHandleUploadCertRequest: ['put', '/v1/certs'] as const,
  newHandleCreateCertRequest: ['post', '/v1/certs'] as const,
  getTypes: ['get', '/v1/params/types'] as const,
  updateTypes: ['post', '/v1/params/types'] as const,
  getStatues: ['get', '/v1/params/statuses'] as const,
  updateStatuses: ['post', '/v1/params/statuses'] as const,
  getCategories: ['get', '/v1/params/categories'] as const,
  updateCategories: ['post', '/v1/params/categories'] as const,
  handleGetCertifications: ['post', '/v1/certs/search'] as const,
  handleSingleSupplierSdi_1: ['get', '/v1/certs/sdis'] as const,
  handleSingleSupplierSdi: ['post', '/v1/certs/sdis'] as const,
  getPermissionsForUser: ['get', '/v1/permissions'] as const,
  getType: ['get', '/v1/params/types/{typeCd}'] as const,
  getStatus: ['get', '/v1/params/statuses/{statusCd}'] as const,
  getCategory: ['get', '/v1/params/categories/{catCd}'] as const,
  handleGetCertBodies: ['get', '/v1/params/bodies/{certCatCd}'] as const,
  handleGetCertRequest: ['get', '/v1/certs/{certId}'] as const,
  handleDeleteCertRequest: ['delete', '/v1/certs/{certId}'] as const,
  toggleExpirationNotification: [
    'get',
    '/v1/certs/{certId}/notify/expiration'
  ] as const,
  handleDownloadCertRequest: [
    'get',
    '/v1/certs/file/{certID}/{filePath}'
  ] as const,
  performHealthCheck: ['get', '/health'] as const
} as const;
